/**
 * Calculates BMI (Body Mass Index).
 * @param {Number} weight
 * @param {Number} height
 * @returns {Number}
 */
const calculateBmi = (weight, height) =>
  (parseFloat(weight) / Math.pow(parseFloat(height), 2)).toFixed(1);
export default calculateBmi;
